import { Box } from "@mui/joy";
import IconButtonCTA from "components/common/IconButtonCTA";
import { darkBorder, textTokens } from "styles/globalStyles";
import { templateDisplayName } from "../../shared/utils/excursionUtils";
import { SCreate } from "styles/StyledMUI";

export type TemplateItem = {
  id?: number;
  name?: string;
  should_be_used_by_default?: boolean;
};

export function TemplatePickerChips<T extends TemplateItem>({
  items,
  selectedId,
  onSelect,
  onSelectNew,
  canEdit,
  ariaLabelNew = "Créer un modèle",
}: {
  items: T[];
  selectedId: number | "new" | null;
  onSelect: (id: number | null) => void;
  onSelectNew?: () => void;
  canEdit: boolean;
  ariaLabelNew?: string;
}) {
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {items.map((t, idx) => (
        <Box
          key={t.id ?? idx}
          component="button"
          type="button"
          onClick={() => onSelect(t.id ?? null)}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
            px: 1.5,
            py: 0.75,
            borderRadius: 6,
            border: darkBorder,
            backgroundColor: selectedId === t.id ? "rgba(252,203,6,0.2)" : "rgba(255,255,255,0.06)",
            color: textTokens.color.primary,
            cursor: "pointer",
            fontSize: "0.875rem",
          }}
        >
          {templateDisplayName(t)}
          {t.should_be_used_by_default && (
            <Box
              component="span"
              sx={{
                px: 0.5,
                py: 0.25,
                borderRadius: 4,
                bgcolor: "rgba(252,203,6,0.3)",
                fontSize: "0.7rem",
              }}
            >
              Par défaut
            </Box>
          )}
        </Box>
      ))}
      {canEdit && onSelectNew && (
        <IconButtonCTA aria-label={ariaLabelNew} ctaVariant="accent" onClick={onSelectNew}>
          <SCreate />
        </IconButtonCTA>
      )}
    </Box>
  );
}
